import {
    assertNumber,
    assertMinimum,
    assertMaximum
} from '../../validators';
import type {
    CommonAttributeSettings,
    CommonMetadataKeys,
    PropDescriptor } from './common';
import {
    DEFAULT_ATTRIBUTE_SETTINGS,
    createPropertyDescription
} from './common';


type NumberAttributeSettings = CommonAttributeSettings & {
     min: number;
     max: number;
};

export type NumberMetadataKeys = keyof NumberAttributeSettings | CommonMetadataKeys;
export const NUMBER_ATTRIBUTE_TYPE = 'numberAttributeType';
const DEFAULT_SETTINGS: NumberAttributeSettings = {
    ...DEFAULT_ATTRIBUTE_SETTINGS,
    min: -Infinity,
    max: Infinity,
    animatable: true,
};

/**
 * Creates an attribute decorator used to describe a numeric property. In addition to the shared
 * attribute settings, the number decorator allows validation to enforce a minimum and a maximum
 * value.
 * @param settings
 */
export function NumberAttribute(settings: Partial<NumberAttributeSettings> = {}) {
    settings = { ...DEFAULT_SETTINGS, ...settings };
    return function(target: object, propertyKey: string, descriptor: PropDescriptor) {
        const validator = (value: number) => {
            assertNumber(value);
            assertMinimum(value, settings.min);
            assertMaximum(value, settings.max);
        };
        return createPropertyDescription(target, propertyKey, descriptor, settings, validator, NUMBER_ATTRIBUTE_TYPE);
    } as any;
}
